import { useEffect, useState } from 'react'
import { useAppActions } from '@obeta/data/lib/hooks/useAppActions'
import { useSubscription } from 'observable-hooks'
import { Box, Typography, useTheme } from '@mui/material'
import { channelLogoutRunning } from '@obeta/app-bootstrap/lib/bootstrapAppActions'

/*
 We use this wrapper to unmount the application during logout, thereby preventing the execution of any effects
  that might interact with the database and slow down the logout process
 */
export const LogoutWrapper = ({ children }) => {
  const [isLogout, setLogout] = useState(false)
  const theme = useTheme()
  const { logout$ } = useAppActions()

  useEffect(() => {
    //this is handling tabs that are open
    channelLogoutRunning.onmessage = (msg) => {
      //if a logout is done, we need to make sure all tabs reload to free their references against the index db
      //elsewise a new connection might not be properly established
      if (msg.phase === 'started') {
        setLogout(true)
      }
      if (msg.phase === 'ended') {
        window.location.replace('/') //we used to have the useRedirectLogout that made all pages go to the startpage to avoid cyclic relogins when the user was on a useAuthenticatedRoute before logging out
      }
    }
  }, [])

  //this handels my own tab
  useSubscription(logout$, () => {
    setLogout(true)
  })

  return isLogout ? (
    <Box
      padding="calc(2rem + var(--obeta-safe-area-top-root)) 2rem"
      bgcolor={theme.palette.background.default}
    >
      <Typography>Sie werden sicher abgemeldet.</Typography>
    </Box>
  ) : (
    children
  )
}
